import { render, staticRenderFns } from "./DeodorizerMonitoring.vue?vue&type=template&id=4879b9b4&scoped=true"
import script from "./DeodorizerMonitoring.vue?vue&type=script&lang=js"
export * from "./DeodorizerMonitoring.vue?vue&type=script&lang=js"
import style0 from "./DeodorizerMonitoring.vue?vue&type=style&index=0&id=4879b9b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4879b9b4",
  null
  
)

export default component.exports